import axios from 'axios';
import { API_URL } from '../Auth/constansts';

const empresaDataAPI = async (token, companyid, id) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/getEmpresaData`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        id: id,
        companyid: companyid
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      return data.data;
    }
    else {
      return 201;
    }
  } catch (error) {
    return 500;
  }
}

const empresaAPI = async (token, id) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/getEmpresa`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        id: id
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      return data.data;
    }
    else {
      return 201;
    }
  } catch (error) {
    return 500;
  }
}

const empresasAPI = async (token, companyid) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/getEmpresas`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        companyid: companyid
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      return data.data;
    }
    else {
      return 201;
    }
  } catch (error) {
    return 500;
  }
}

const empresaCreate = async (
  token,
  companyid,
  name,
  address,
  phone,
  nit,
  email,
  website,
  description,
  color,
  logo
) => {
  try {
    const time = new Date().valueOf();
    const message = "@" + time + "#" + companyid + 
      name + 
      address + 
      phone + 
      nit+ 
      email+ 
      website+ 
      description+
      color+
      logo + "@";
    const encoder = new TextEncoder();
    const datas = encoder.encode(message);
    const digest = await crypto.subtle.digest("SHA-512", datas);
    const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, "0"))
      .join(""); // convert bytes to hex string

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${API_URL}/setEmpresa`,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    data: {
      companyid: companyid,
      name: name,
      address: address,
      phone: phone,
      nit: nit,
      email: email,
      website: website,
      description: description,
      color: color,
      logo: logo,
      timestamp:time,
      signature:hashHex
    }
  };
  const data = await axios.request(config);
  if (data.status === 200) {
    return data.data;
  }
  else {
    return 201;
  }
} catch (error) {
  return error;
}
}


const representanteempresaCreate = async (token, mcompanyid, companyid, name, lastname, dtype, dnumber) => {
  try {

    const time = new Date().valueOf();
    const message = "@" + time + "#" 
    + mcompanyid 
    + companyid 
    + name 
    + lastname 
    + dtype 
    + dnumber
    + "@";
    const encoder = new TextEncoder();
    const datas = encoder.encode(message);
    const digest = await crypto.subtle.digest("SHA-512", datas);
    const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, "0"))
      .join(""); // convert bytes to hex string

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/setEmpresaRepresentante`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        mcompanyid: mcompanyid,
        company: companyid,
        name: name,
        last: lastname,
        dtype: dtype,
        dnumber: dnumber,
        timestamp:time,
        signature:hashHex 
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      return data.data;
    }
    else {
      return 201;
    }
  } catch (error) {
    return error;
  }
}


const representanteempresaShow = async (token, companyid) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/getEmpresaRepresentante`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        company: companyid
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      return data.data;
    }
    else {
      return 201;
    }
  } catch (error) {
    return error;
  }
}

export {
  empresaAPI,
  empresasAPI,
  empresaCreate,
  representanteempresaCreate,
  representanteempresaShow,
  empresaDataAPI
}